import { render, staticRenderFns } from "./activity-session-attendees.vue?vue&type=template&id=8bb5aa40&scoped=true&"
import script from "./activity-session-attendees.ts?vue&type=script&lang=ts&"
export * from "./activity-session-attendees.ts?vue&type=script&lang=ts&"
import style0 from "./activity-session-attendees.scss?vue&type=style&index=0&id=8bb5aa40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb5aa40",
  null
  
)

export default component.exports